import React,{useContext} from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import CheckIcon from "@material-ui/icons/Check";
import SaveIcon from "@material-ui/icons/Save";
import {CurrentUserDetailsContext} from "../../contexts/userDetails";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function Progress({
  buttonContent,
  handleProgressSubmit,
  submitCartToFirestore,
  userDetails,
  setUserDetails,
  cart,
  shippingData,
  makeid,
  referenceNumber
}) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef();
  const [currentUserDoc, setCurrentUserDoc] = useContext(CurrentUserDetailsContext);

  

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleButtonClick = () => {
    // makeid();
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      
      submitCartToFirestore();
      timer.current = window.setTimeout(() => {
        setSuccess(true);
        setLoading(false);
        let orderNumber = userDetails?.orders?.length + 1;
        // makeid();
        setCurrentUserDoc((prevState) => {
          let prevStateCopy = { ...prevState };
          prevStateCopy.orders.push({orderNumber, date : new Date(), shippingAddress : {...shippingData}, referenceNumber:makeid()});
          prevStateCopy[orderNumber] = [...cart];
          return { ...prevStateCopy };
        });
        // submitCartToFirestore();
        setTimeout(() => {
          handleProgressSubmit();
        }, 100);
      }, 3000);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Button
          variant="contained"
          color="primary"
          className={buttonClassname}
          disabled={loading}
          onClick={handleButtonClick}
        >
          {buttonContent}
        </Button>
        {loading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </div>
  );
}

{
  /* <div className={classes.wrapper}>
        <Fab
          aria-label="save"
          color="primary"
          className={buttonClassname}
          onClick={handleButtonClick}
        >
          {success ? <CheckIcon /> : <SaveIcon />}
        </Fab>
        {loading && <CircularProgress size={68} className={classes.fabProgress} />}
      </div> */
}
